"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PickersLocalizationProvider = void 0;
const react_1 = __importStar(require("react"));
const x_date_pickers_1 = require("@mui/x-date-pickers");
const AdapterDayjs_1 = require("@mui/x-date-pickers/AdapterDayjs");
const ThemeProvider_1 = require("./ThemeProvider");
const PickersLocalizationProvider = ({ children }) => {
    var _a;
    const locale = (_a = (0, react_1.useContext)(ThemeProvider_1.LanguageContext)) !== null && _a !== void 0 ? _a : ThemeProvider_1.Language.En;
    const localeTextMap = {
        [ThemeProvider_1.Language.Fr]: x_date_pickers_1.frFR.components.MuiLocalizationProvider.defaultProps.localeText,
        [ThemeProvider_1.Language.En]: x_date_pickers_1.enUS.components.MuiLocalizationProvider.defaultProps.localeText,
    };
    return (react_1.default.createElement(x_date_pickers_1.LocalizationProvider, { dateAdapter: AdapterDayjs_1.AdapterDayjs, adapterLocale: locale, localeText: localeTextMap[locale] }, children));
};
exports.PickersLocalizationProvider = PickersLocalizationProvider;
//# sourceMappingURL=PickersLocalizationProvider.js.map